//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import $ from 'jquery';
import axios from 'axios';

export default {
  layout: function layout(context) {
    return global.getTheme();
  },
  data: function data() {
    return {
      errorMessage: '',
      placeHolderMessage: '',
      results: [],
      loading: false,
      view: 'default'
    };
  },
  mounted: function mounted() {},

  computed: {
    lang: function lang() {
      return this.$root._route.params.lang;
    }
  },
  created: function created() {
    this.view = global.getTheme();
    if (process.client) {
      this.loading = true;
      this.isAuth = this.$auth.isAuthenticated();
      this.refreshLoggedUser();
      if (!this.isAuth) {
        this.$router.push({ name: 'lang-login', params: { lang: this.lang } });
      }
      this.getAllCharges();
    }
  },

  methods: {
    getAllCharges: function getAllCharges() {
      var _this = this;

      this.loading = true;
      if (global.websiteSettings.extra_info.payment_package_unique_identifier === 'stripe') {
        axios.get(global.getEndPoint() + 'api/stripe/all-charges').then(function (resp) {
          _this.results = resp.data;
          _this.loading = false;
        });
      } else if (global.websiteSettings.extra_info.payment_package_unique_identifier === 'paymentwall') {
        axios.get(global.getEndPoint() + 'api/paymentwall/all-charges').then(function (resp) {
          _this.results = resp.data;
          _this.loading = false;
        });
      }
    },
    refreshLoggedUser: function refreshLoggedUser() {
      this.$auth.getUser(function (user) {
        this.loggedUser = user;
      }.bind(this));
    },
    doRefund: function doRefund(charge) {
      var _this2 = this;

      if (confirm(this.$root.trans('st_public.are you sure?'))) {
        var requestParams = {};
        requestParams.charge = charge;
        this.loading = true;
        if (global.websiteSettings.extra_info.payment_package_unique_identifier === 'stripe') {
          axios.post(global.getEndPoint() + 'api/stripe/refund', requestParams).then(function (resp) {
            _this2.loading = false;
            if (resp.data.status == 1) {
              _this2.getAllCharges();
              flash(_this2.$root.trans('st_public.refund has been done successfully'), 'success');
            } else {
              flash(_this2.$root.trans('st_public.' + res.data.message), 'error');
            }
          });
        } else if (global.websiteSettings.extra_info.payment_package_unique_identifier === 'paymentwall') {
          axios.post(global.getEndPoint() + 'api/paymentwall/refund', requestParams).then(function (resp) {
            _this2.loading = false;
            if (resp.data.status == 1) {
              _this2.getAllCharges();
              flash(_this2.$root.trans('st_public.refund has been done successfully'), 'success');
            } else {
              flash(_this2.$root.trans('st_public.' + res.data.message), 'error');
            }
          });
        }
      }
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/var/www/html/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/_lang/member/all-charges.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/var/www/html/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/_lang/member/all-charges.vue
// module chunks = 39